import { notContainsOnlySpaces } from "../../../utils";

export const validationReleaseGroupInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationReleaseOSInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }
  if ("operatingSystem" in fieldValues) {
    temp.operatingSystem = notContainsOnlySpaces(fieldValues.operatingSystem)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationReleaseTypeSpeakerInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }
  if ("typeSpeaker" in fieldValues) {
    temp.typeSpeaker = notContainsOnlySpaces(fieldValues.typeSpeaker)
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationReleaseAppVersionInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("versionName" in fieldValues) {
    temp.versionName = notContainsOnlySpaces(fieldValues.versionName)
      ? ""
      : "This field is required.";
  }

  if ("appVersion" in fieldValues) {
    temp.appVersion = notContainsOnlySpaces(fieldValues.appVersion)
      ? ""
      : "This field is required.";
  }

  if ("operatingSystemId" in fieldValues) {
    temp.operatingSystemId = notContainsOnlySpaces(
      fieldValues.operatingSystemId
    )
      ? ""
      : "This field is required.";
  }

  return temp;
};

export const validationReleaseSpeakerVersionInput = (fieldValues, temp) => {
  if ("name" in fieldValues) {
    temp.name = notContainsOnlySpaces(fieldValues.name)
      ? ""
      : "This field is required.";
  }

  if ("versionName" in fieldValues) {
    temp.versionName = notContainsOnlySpaces(fieldValues.versionName)
      ? ""
      : "This field is required.";
  }

  if ("versionCode" in fieldValues) {
    temp.versionCode = notContainsOnlySpaces(fieldValues.versionCode)
      ? ""
      : "This field is required.";
  }

  if ("packageName" in fieldValues) {
    temp.packageName = notContainsOnlySpaces(fieldValues.packageName)
      ? ""
      : "This field is required.";
  }

  if ("typeSpeakerId" in fieldValues) {
    temp.typeSpeakerId = notContainsOnlySpaces(fieldValues.typeSpeakerId)
      ? ""
      : "This field is required.";
  }

  return temp;
};
